import React from "react";
import { UserPlanEnum } from "../../../constants/plans";
import { useAuth } from "../../../contexts/AuthContext";
import iconWpp from "../../../assets/icons/sidebar/whatsapp.svg";
import arrow from "../../../assets/icons/sidebar/right-arrow.svg";
import { useRequireAccess } from "../../../contexts/RequireAccessContext";
import { useNavigate } from "react-router-dom";
import {
  ContentSupportWpp,
  TextContainer,
  InfoText,
  ScheduleText,
  Button,
  ContentNotHasAccess,
  InfoText2,
  ContentCommercial,
} from "./styles";

interface SupportModuleProps {
  closeFn: () => void;
}

const SupportModule: React.FC<SupportModuleProps> = ({ closeFn }) => {
  const { user, hasPlan } = useAuth();
  const { escritorioLiberados } = useRequireAccess();
  const navigate = useNavigate();

  const userPlanType = user?.user?.userPlanInfoVelotax?.type;
  const habilitado =
    escritorioLiberados.length > 0
      ? escritorioLiberados.find((e: any) => e.liberadaContratacao)
      : false;

  // Lógica para determinar o tipo de plano e o acesso
  const isConciergePlan =
    userPlanType?.includes("CONCIERGE") ||
    userPlanType === UserPlanEnum.XP_CONCIERGE ||
    userPlanType === UserPlanEnum.VELOTAX_MAIN_CONCIERGE;

  const isPremiumPlan =
    userPlanType?.includes("PRO") ||
    userPlanType === UserPlanEnum.XP_PRO ||
    userPlanType === UserPlanEnum.XP_PRO_MONTH ||
    userPlanType === UserPlanEnum.VELOTAX_MAIN_PRO ||
    userPlanType === UserPlanEnum.VELOTAX_MAIN_PRO_MONTH;

  const isBasicPlan =
    userPlanType?.includes("BASIC") ||
    userPlanType === UserPlanEnum.XP_BASIC ||
    userPlanType === UserPlanEnum.VELOTAX_MAIN_BASIC;

  const hasAccess =
    isConciergePlan ||
    (isPremiumPlan && habilitado) ||
    (isBasicPlan && habilitado);

  const handleClick = () => {
    if (hasAccess) {
      const nameUser = user?.user?.name;

      const mensagem = `Olá, meu nome é ${nameUser} e preciso de ajuda.`;
      const messageChat = encodeURIComponent(mensagem);
      const urlWhatsapp = `https://wa.me/+5511912342309?text=${messageChat}`;

      window.open(urlWhatsapp);
    }
  };

  const handleClickComercial = () => {
    const nameUser = user?.user?.name;

    const mensagem = `Olá, meu nome é ${nameUser} e quero falar com a equipe do comercial`;
    const messageChat = encodeURIComponent(mensagem);
    const urlWhatsapp = `https://wa.me/+5521995275100?text=${messageChat}`;

    window.open(urlWhatsapp);
  };

  const handleUpgradeClick = () => {
    navigate("/planos", {
      state: { planLocal: "CONCIERGE" },
    });
    closeFn();
  };

  const actionTypeText = !hasPlan ? "CONTRATAR" : "FAZER UPGRADE";

  return (
    <ContentSupportWpp
      title="dúvidas"
      onClick={handleClick}
      hasAccess={hasAccess}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        {!hasAccess ? (
          <>
            <ContentNotHasAccess>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  flexDirection: "column",
                }}
              >
                <TextContainer>
                  <InfoText2>
                    Tenha acesso a um suporte de alta qualidade. Contrate o{" "}
                    <strong style={{ fontWeight: "bold" }}> Concierge </strong>{" "}
                    e conecte-se com nossa equipe de especialistas.
                  </InfoText2>
                </TextContainer>
                <Button onClick={handleUpgradeClick}>{actionTypeText}</Button>
              </div>
              <ContentCommercial onClick={handleClickComercial}>
                <InfoText2>Fale com nosso comercial</InfoText2>
                <img
                  src={arrow}
                  alt="arrow"
                  style={{
                    width: "14px",
                    height: "14px",
                    marginTop: "4px",
                  }}
                />
              </ContentCommercial>
            </ContentNotHasAccess>
          </>
        ) : (
          <>
            <TextContainer>
              <InfoText>Fale com nossos especialistas</InfoText>
              <ScheduleText>Seg à Sex - (9h às 19h)</ScheduleText>
            </TextContainer>
            <img
              src={iconWpp}
              alt="wpp"
              style={{
                width: "48px",
                height: "48px",
              }}
            />
          </>
        )}
      </div>
    </ContentSupportWpp>
  );
};

export default SupportModule;